import { render, staticRenderFns } from "./ArchivedProject.vue?vue&type=template&id=17a3c6e2"
import script from "./ArchivedProject.vue?vue&type=script&lang=js"
export * from "./ArchivedProject.vue?vue&type=script&lang=js"
import style0 from "./ArchivedProject.vue?vue&type=style&index=0&id=17a3c6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports